/** @format */
import { ProductItemSummary } from '@toucan/client/global/transaction';

import { UNLISTED_MODEL_ID } from '../config/constants';

export const isUnlistedModel = (product: ProductItemSummary) =>
    product.modelId === UNLISTED_MODEL_ID;
